import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DateRange } from "react-day-picker";
import { SortOptionKey } from "../views/ProductsView/ProductsFilters";
import { CategoryGroupItem, QualityGroup } from "../types/api";
import { JobFilter } from "../views/JobsView/JobsView";

export interface FiltersState {
  searchKeyword: string;
  selectedTags: string[];
  date: DateRange | undefined;
  sortBy: SortOptionKey | undefined;
  currentPage: number;
  qualityGroup: QualityGroup;
  jobFilter: JobFilter;
  categoryHierarchy: string[];
  categoryName: string[];
  productType: string[];
}

export const filtersInitialState: FiltersState = {
  searchKeyword: "",
  selectedTags: [],
  date: undefined,
  sortBy: "created_at-desc",
  currentPage: 1,
  qualityGroup: "all_products",
  jobFilter: "all",
  categoryHierarchy: [],
  categoryName: [],
  productType: [],
};

export const filtersSlice = createSlice({
  name: "filters",
  initialState: filtersInitialState,
  reducers: {
    setJobFilter: (state, action: PayloadAction<JobFilter>) => {
      state.jobFilter = action.payload;
    },
    setSearchKeyword: (state, action: PayloadAction<string>) => {
      state.searchKeyword = action.payload;
    },
    setSelectedTags: (state, action: PayloadAction<string[]>) => {
      state.selectedTags = action.payload;
    },
    setDateRange: (state, action: PayloadAction<DateRange | undefined>) => {
      state.date = action.payload;
    },
    setSortBy: (state, action: PayloadAction<SortOptionKey | undefined>) => {
      state.sortBy = action.payload;
    },
    setCurrentPage: (state, action: PayloadAction<number>) => {
      state.currentPage = action.payload;
    },
    setQualityGroup: (state, action: PayloadAction<QualityGroup>) => {
      state.qualityGroup = action.payload;
    },
    setFilters: (state, action: PayloadAction<FiltersState>) => {
      state.searchKeyword = action.payload.searchKeyword;
      state.selectedTags = action.payload.selectedTags;
      state.date = action.payload.date;
      state.sortBy = action.payload.sortBy;
      state.currentPage = action.payload.currentPage;
      state.qualityGroup = action.payload.qualityGroup;
      state.categoryHierarchy = action.payload.categoryHierarchy;
      state.categoryName = action.payload.categoryName;
      state.productType = action.payload.productType;
    },
    clearFilters: (state) => {
      state.searchKeyword = filtersInitialState.searchKeyword;
      state.selectedTags = filtersInitialState.selectedTags;
      state.date = filtersInitialState.date;
      state.sortBy = filtersInitialState.sortBy;
      state.currentPage = filtersInitialState.currentPage;
      state.qualityGroup = filtersInitialState.qualityGroup;
      state.categoryHierarchy = filtersInitialState.categoryHierarchy;
      state.categoryName = filtersInitialState.categoryName;
      state.productType = filtersInitialState.productType;
    },
  },
});

export const {
  setSearchKeyword,
  setSelectedTags,
  setDateRange,
  setSortBy,
  setCurrentPage,
  clearFilters,
  setQualityGroup,
  setFilters,
  setJobFilter,
} = filtersSlice.actions;

export default filtersSlice.reducer;
